// Module
var code = `<div class="modal fade" id="confirmSolutionModal" tabindex="-1" role="dialog" data-bind="showModal: show">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" data-bind="label: 'cc_P_USE_SOLUTION_CONFIRMATION'"></h4>
      </div>
      <div class="modal-body">
        <div style="font-weight: bold; margin: 10px 0 5px 0" data-bind="label:'cc_P_YOUR_COMMENT'"></div>

        <textarea rows="6" style="width: 100%; border: 2px solid #3eb8a1" maxlength="2000" data-bind="value:comment">
        </textarea>

        <div style="display: flex; flex-direction: row; align-items: center">
          <div style="font-weight: bold" data-bind="label:'cc_P_YOUR_RATING'"></div>
          <star-rating style="margin-left: 10px" params="rating: rating"> </star-rating>
        </div>

        <div>
          <!-- ko if: submittedAttachments().length > 0 -->
          <!-- ko foreach: submittedAttachments()-->
          <div
            style="
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              color: #555;
              padding: 10px 15px;
              background-color: #fff;
              border: 1px solid #ddd;
            "
          >
            <input type="checkbox" data-bind="checked: is_selected" style="margin-right: 15px" ></input>
            <div>
              <span data-bind="text: attachment().attachment_name"></span>
              <br ></br>
              <strong style="font-size: smaller" data-bind="text: attachment().attachment_description"></strong>
            </div>
          </div>
          <!-- /ko -->
          <!-- /ko -->
        </div>
      </div>
      <div class="modal-footer">
        <div style="display: flex; align-items: center; justify-content: space-around">
          <button type="button" class="btn btn-default" data-bind="click: cancel, label: 'cc_P_CANCEL'"></button>
          <button
            type="button"
            class="btn btn-default"
            data-bind="click: confirm, label: 'cc_P_CONFIRM', enable: canSubmitSolution"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
`;
// Exports
module.exports = code;